// extracted by mini-css-extract-plugin
module.exports = {"language-picker":"_1djeS8y50Em_DvSM9LF7My"};